<template>
  <div class="o-container o-container--xlarge">
    <section>
      <h2 v-if="!fairSeries._id">Neue Messe-Reihe erfassen</h2>
      <h2 v-if="fairSeries._id">Messe-Reihe bearbeiten</h2>
      <div class="o-grid o-grid--no-gutter">
        <div class="o-grid__cell top-buttons">
          <bos-button @click="saveFairSeries">Messe-Reihe speichern</bos-button>
        </div>
      </div>
    </section>
    <section>
      <div class="o-grid o-grid--no-gutter">
        <div class="o-grid__cell o-grid__cell--width-100">
          <div v-if="fairSeries._id">
            <bos-input
              label="Parametrisierter Link"
              v-model="parameterLink"
              :readonly="true"
            />
          </div>
          <bos-input
            v-model="fairSeries.titleDe"
            key="titleDe"
            :error="errors.titleDe"
            label="Bezeichnung (de):"
            :required="true"
          />
          <bos-input
            v-model="fairSeries.titleFr"
            key="titleFr"
            :error="errors.titleFr"
            label="Bezeichnung (fr):"
            :required="true"
          />
          <bos-input
            v-model="fairSeries.titleEn"
            key="titleEn"
            :error="errors.titleEn"
            label="Bezeichnung (en):"
            :required="true"
          />
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import BosButton from '@/components/BosButton'
import BosInput from '@/components/BosInput'
import ApiService from '@/services/ApiService'
import FormValidator from '@/services/FormValidator'

export default {
  name: 'AdminCoreDataFairSeriesCreate',
  components: {
    //BosDocumentEntry,
    BosInput,
    BosButton
  },
  props: {
    msg: String
  },
  data() {
    return {
      fairSeries: {},
      errors: {
        titleDe: {
          hasError: false
        },
        titleFr: {
          hasError: false
        },
        titleEn: {
          hasError: false
        }
      }
    }
  },
  computed: {
    parameterLink() {
      return (
        document.location.protocol +
        '//' +
        document.location.host +
        '/?_fs=' +
        this.fairSeries._id
      )
    }
  },
  methods: {
    getValidateFairSeries() {
      //rules
      return [
        {
          value: this.fairSeries.titleDe,
          required: true,
          errorKey: 'titleDe'
        },
        {
          value: this.fairSeries.titleFr,
          required: true,
          errorKey: 'titleFr'
        },
        {
          value: this.fairSeries.titleEn,
          required: true,
          errorKey: 'titleEn'
        }
      ]
    },
    saveFairSeries() {
      FormValidator.validateForm(
        this.getValidateFairSeries(),
        this.errors
      ).then(() => {
        let action = this.$route.params.id
          ? 'updateFairSeries'
          : 'createFairSeries'
        let allowedStates = [200, 201]

        ApiService[action](this.fairSeries).then(
          result => {
            if (allowedStates.includes(result.status)) {
              this.$router.push({ name: 'AdminCoredataFairSeriesOverview' })
            }
          },
          error => {
            console.warn(error)
          }
        )
      })
    }
  },
  mounted() {
    if (this.$route.params.id) {
      ApiService.getFairSeriesById(this.$route.params.id).then(res => {
        this.fairSeries = res.data
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '@/assets/css/variables.scss';

.o-admin__teaser {
  padding: 6rem 0;
}

.list-group-item {
  padding: 0.333rem 0;
  vertical-align: center;
  display: block;

  &:nth-child(even) {
    background-color: #f7f6f3;
  }
}

h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.bos-timeflow {
  text-align: center;
  list-style: none;
  display: inline-table;
  margin: 0 0 4rem 0;

  li {
    display: inline;
    margin: 0;

    span {
      display: block;
      float: left;
      height: 44px;
      background: rgba(104, 115, 116, 0.3);
      text-align: center;
      padding: 14px 10px 0 30px;
      position: relative;
      margin: 0 4px 0 0;

      font-size: $timeflow-font-size;
      text-decoration: none;
      color: #fff;

      &:after {
        content: '';
        border-top: 22px solid transparent;
        border-bottom: 22px solid transparent;
        border-left: 20px solid rgba(104, 115, 116, 0.3);
        position: absolute;
        right: -20px;
        top: 0;
        z-index: 1;
      }

      &:before {
        content: '';
        border-top: 22px solid transparent;
        border-bottom: 22px solid transparent;
        border-left: 20px solid #fff;
        position: absolute;
        left: 0;
        top: 0;
      }
    }

    &:first-child span {
      padding-left: 24px;

      &:before {
        display: none;
      }
    }

    &:last-child span {
      padding-right: 20px;

      &:after {
        display: none;
      }
    }

    &.active span {
      background: rgba(46, 150, 153, 0.7);

      &:after {
        border-left-color: rgba(46, 150, 153, 0.7);
      }
    }
  }
}

.top-buttons {
  float: right;
  text-align: right;

  button {
    margin-right: 1.333rem;

    &:last-of-type {
      margin-right: 0;
    }
  }
}

hr {
  margin: 1.333rem 0 4rem 0;
  border: none;
  border-bottom: 1px solid #c9c9c9;
}

.empty {
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  padding: 0.333rem;
  &:after {
    display: block;
    width: 100%;
    content: 'hierher ziehen';
    text-align: center;
    color: rgba(0, 0, 0, 0.3);
  }
}

input.fileinput.error + label {
  color: red;
}
</style>
